module.exports = __webpack_public_path__ + "static/media/achievement-red-ruby-slippers.c6e98bd3.svg";